import React, { FC, memo } from 'react'
import * as S from './styles'
import { ContentProps } from './types'

export const Content: FC<ContentProps> = memo(({ content, inverse = false, ...rest }) => (
  <S.Content {...rest} inverse={inverse} dangerouslySetInnerHTML={{ __html: content }} />
))

Content.displayName = 'Content'
